import { Route, Routes, useLocation } from "react-router-dom";
import Loader from "./components/layouts/loading/loading";
import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAdminDetails } from "./store/AuthSlice";

const Logs = React.lazy(() => import("./pages/Logs"));
const Offers = React.lazy(() => import("./pages/offers/Offers"));
const AddOffer = React.lazy(() => import("./pages/offers/AddOffer"));
const EditeOffer = React.lazy(() => import("./pages/offers/EditeOffer"));
const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const Admin = React.lazy(() => import("./pages/admin/Admin"));
const AddAdmin = React.lazy(() => import("./pages/admin/AddAdmin"));
const AdminEdit = React.lazy(() => import("./pages/admin/AdminEdit"));

const Login = React.lazy(() => import("./pages/auth/login"));
const Protected = React.lazy(() => import("./pages/auth/Protected"));
// const Branches = React.lazy(() => import("./pages/branches/branches"));
// const AddBrancWrap = React.lazy(() => import("./pages/branches/AddBrancWrap"));
// const ViewBranch = React.lazy(() => import("./pages/branches/ViewBranch"));
const EditeBranchWrap = React.lazy(() =>
  import("./pages/branches/EditeBranchWrap")
);
const Profile = React.lazy(() => import("./pages/setting/Profile"));
const Contracts = React.lazy(() => import("./pages/setting/Contracts"));
const Agree = React.lazy(() => import("./pages/setting/Agree"));
const Disagree = React.lazy(() => import("./pages/setting/Disagree"));
const InfoContract = React.lazy(() => import("./pages/setting/InfoContract"));

const EditeProfileWrap = React.lazy(() =>
  import("./pages/setting/EditeProfileWrap")
);
const Products = React.lazy(() => import("./pages/products/products"));
const EditProducts = React.lazy(() => import("./pages/products/EditProducts"));
const AddProducts = React.lazy(() => import("./pages/products/AddProducts"));
const ViewProducts = React.lazy(() => import("./pages/products/ViewProducts"));

const AddOrder = React.lazy(() => import("./pages/orders/AddOrder"));
const Orders = React.lazy(() => import("./pages/orders/Orders"));
const ViewOrder = React.lazy(() => import("./pages/orders/ViewOrder"));

function App() {
  const dispatch = useDispatch();
  const { isAuthLoading, AdminDetailsArr } = useSelector(
    (state) => state.AuthSlice
  );
  const { isRestaurantLoading } = useSelector(
    (state) => state.RestaurantsSlice
  );
  const { isProductLoading } = useSelector((state) => state.ProductSlice);
  const { isOffersLoading } = useSelector((state) => state.OffersSlice);
  const { isStstisticsLoading } = useSelector((state) => state.StstisticsSlice);
  useEffect(() => {
    if (!AdminDetailsArr) {
      dispatch(getAdminDetails());
    }
  }, [dispatch, AdminDetailsArr]);
    const location = useLocation();
    const lang = location.pathname.includes('/ar') ? 'ar' : 'en';
  return (
    <div className={` ${lang === "ar" ? "App_ar" : "App_en"}`}>
      {isAuthLoading && <Loader />}
      {isRestaurantLoading && <Loader />}
      {isProductLoading && <Loader />}
      {isOffersLoading && <Loader />}
      {isStstisticsLoading && <Loader />}
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route element={<Protected />}>
            <Route path="*" element={<Profile />} />
            <Route path="/:lang" element={<Profile />} />
            {AdminDetailsArr?.permissions?.show_admin && (
              <>
                <Route path="/Admin/:lang" element={<Admin />} />
                <Route path="/AddAdmin/:lang" element={<AddAdmin />} />
                <Route path="/AdminEdit/:id/:lang" element={<AdminEdit />} />
              </>
            )}
            {AdminDetailsArr?.permissions?.show_branches && (
              <>
                {/* <Route path="/Branches/:lang" element={<Branches />} /> */}
                {/* <Route path="/AddBranch/:lang" element={<AddBrancWrap />} /> */}
                {/* <Route path="/ViewBranch/:id/:lang" element={<ViewBranch />} /> */}
                <Route
                  path="/EditBranch/:id/:lang"
                  element={<EditeBranchWrap />}
                />
              </>
            )}
            {AdminDetailsArr?.permissions?.show_products && (
              <>
                <Route path="/products/:lang" element={<Products />} />
                <Route path="/AddProducts/:lang" element={<AddProducts />} />
                <Route
                  path="/ViewProducts/:id/:lang"
                  element={<ViewProducts />}
                />
                <Route
                  path="/EditProducts/:id/:lang"
                  element={<EditProducts />}
                />
              </>
            )}

            {/* {AdminDetailsArr?.permissions?.show_settings && (
              <>
                <Route path="/Profile/:lang" element={<Profile />} />
                <Route
                  path="/EditProfile/:lang"
                  element={<EditeProfileWrap />}
                />
              </>
            )} */}

            {/* Offers */}
            {AdminDetailsArr?.permissions?.show_offer && (
              <>
                <Route path="/Offers/:lang" element={<Offers />} />
                <Route path="/AddOffers/:lang" element={<AddOffer />} />
                <Route path="/EditeOffers/:id/:lang" element={<EditeOffer />} />
              </>
            )}

            <Route path="/Contracts/:lang" element={<Contracts />} />
            <Route path="/InfoContract/:id/:lang" element={<InfoContract />} />
            <Route path="/Agree/:id/:lang" element={<Agree />} />
            <Route path="/Disagree/:id/:lang" element={<Disagree />} />

            <>
              <Route path="/Profile/:lang" element={<Profile />} />
              <Route path="/EditProfile/:lang" element={<EditeProfileWrap />} />
            </>

            {AdminDetailsArr?.permissions?.show_orders && (
              <>
                <Route path="/AddOrder/:lang" element={<AddOrder />} />
                <Route path="/Orders/:lang" element={<Orders />} />
                <Route path="/ViewOrder/:id/:lang" element={<ViewOrder />} />
              </>
            )}
            {/* <Route
              path="/statistics/restaurant-products/:lang"
              element={<StatisticsOrders />}
            />
            <Route path="/statistics/revenue/:lang" element={<Revenue />} /> */}
            <Route path="/dashboard/:lang" element={<Dashboard />} />
            <Route path="/logs/:lang" element={<Logs />} />
            {/* Dashboard */}
          </Route>
          <Route path="/login/:lang" element={<Login />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
